module.exports = __webpack_public_path__ + "img/download1.0afd68ea.png";